import { AI_CHAT_INTERACTIVE_SLIDE_NAMES } from '@/constant/slideTypes'
import OpenAIUtils from '@/utils/open-ai/OpenAIUtils'

const SET_PROMPT_SUGGESTIONS = 'SET_PROMPT_SUGGESTIONS'

const _state = {
  promptSuggestions: [],
}

const _getters = {
  promptSuggestions: (state) => state.promptSuggestions,
}

const actions = {
  getPromptSuggestionsAction({ commit, rootState }) {
    const userCountry = rootState.currentUser.country ? rootState.currentUser.country : 'Singapore'
    const userCity = rootState.currentUser.city ? rootState.currentUser.city : 'Paris'
    const engagingTopics = ['the history of the internet', 'data analysis', 'recent economic trends', 'digital marketing', 'coding best practices', 'remote work', 'personal finance']

    const interactiveSlide = OpenAIUtils.getRandomItemsInArray(AI_CHAT_INTERACTIVE_SLIDE_NAMES, 1)
    const countryOrCity = OpenAIUtils.getRandomItemsInArray([userCountry, userCity], 1)
    const icebreakerTopic = OpenAIUtils.getRandomItemsInArray(['Funny icebreaker questions', '3 witty quizzes to break silences'], 1)
    const randomTopic = OpenAIUtils.getRandomItemsInArray(engagingTopics, 1)

    const allExamples = [
      `A presentation of 10 slides about ${countryOrCity}`,
      `${icebreakerTopic}`,
      `2 challenging ${interactiveSlide} quizzes about ${userCity}`,
      `Create an engaging presentation about ${randomTopic}`,
    ]

    commit(SET_PROMPT_SUGGESTIONS, OpenAIUtils.getRandomItemsInArray(allExamples, 4))
  },
}

const mutations = {
  [SET_PROMPT_SUGGESTIONS](state, value) {
    state.promptSuggestions = value
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
